import React, { useEffect, useState } from "react";
import "./style.css";
import filterIcon from "../../../Assets/Icons/filter-icon.svg";
// import searchIcon from "../../../Assets/Icons/search-icon.svg";
import timelineIcon from "../../../Assets/Icons/timeline-icon.svg";
import showMoreIcon from "../../../Assets/Icons/showMore-icon.svg";
import showLessIcon from "../../../Assets/Icons/icon_show_less.png";
import tableViewIcon from "../../../Assets/Icons/icon_table_view.png";
import Table from "../Table";
import Timeline from "../Timeline";
import ViewReportModal from "../../Elements/Modal/viewReportModal";
import InvestigationsFilter from "../Modal/InvestigationsFilter";
// import { usePatientContext } from "../../../Context/PatientContext";
import { getDDMMYY } from "../../../Helpers/index";
import {
  downloadCuratedFile,
  getCuratedFilesList,
  getPatientTimeline,
} from "../../../Services";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import FlyerMessage from "../FlyerMessage";
import { usePatientContext } from "../../../Context/PatientContext";

const InvestigationAndTreatment = ({ updateBreadCrumb }) => {
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();
  const { patientTimeline, updatePatientTimeline, patientDetails } =
    usePatientContext();
  const [completeTimeline, setCompleteTimeline] = useState([]);
  const [timelineView, setTimelineView] = useState(false);
  const [showMore, setShowMore] = useState(true);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isViewReportModalOpen, setViewReportModalOpen] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState({
    success: false,
    fail: false,
  });
  // const { patientTimeline } = usePatientContext();
  // const investigations = patientTimeline.filter(
  //   (entry) => entry?.type === "investigations"
  // );
  const [investigations, setInvestigations] = useState([]);
  const [allFiles, setAllFiles] = useState([]);
  const [options, setOptions] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    investigationFilters: [],
    treatmentFilters: [],
    otherFilters: [],
    duration: [],
  });
  const [filterDates, setFilterDates] = useState({
    startMonth: null,
    endMonth: null,
    startYear: null,
    endYear: null,
  });
  const [currSort, setCurrSort] = useState({ field: "", dir: 1 });
  const [recordURL, setRecordURL] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedReportDetails, setSelectedReportDetails] = useState({});
  const [viewModalType, setViewModalType] = useState("view");
  const [rows, setRows] = useState([]);

  const getPatientDetails = async () => {
    try {
      const timelineResponse = await getPatientTimeline(
        physician.physician._id,
        patientId
      );
      if (!timelineResponse.error) {
        updatePatientTimeline(timelineResponse.data);
        setCompleteTimeline(timelineResponse.data);
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  /**
   * Function to handle show more and show less
   */
  const handleShowMore = (show) => {
    const container = document.getElementById("summary-and-parameters");

    if (show) {
      container.style.display = "none";
      if (!timelineView) {
        updateBreadCrumb([
          { name: "Dashboard", url: "/dashboard" },
          {
            name: `${patientDetails.firstName} ${patientDetails.lastName}`,
            url: `/patient/${patientId}`,
          },
          { name: "Investigation and Treatment" },
        ]);
      } else {
        updateBreadCrumb([
          { name: "Dashboard", url: "/dashboard" },
          {
            name: `${patientDetails.firstName} ${patientDetails.lastName}`,
            url: `/patient/${patientId}`,
          },
          { name: "Timeline" },
        ]);
      }
    } else {
      container.style.display = "flex";
      updateBreadCrumb([
        { name: "Dashboard", url: "/dashboard" },
        {
          name: `${patientDetails.firstName} ${patientDetails.lastName}`,
        },
      ]);
    }
  };

  const handleFilter = () => {
    setIsFilterModalOpen(true);
  };

  const handleButtonClick = async (row, btnIndex) => {
    const button = row.tableData[4].buttonList[btnIndex];
    setViewModalType(button.btnAction);

    // Access the unique identifier from the clicked row
    const reportId = row._id;

    // Find the corresponding investigation object for the clicked row using the identifier
    const clickedInvestigation = investigations.find(
      (investigation) => investigation._id === reportId
    );
    if (button.btnAction === "view" || button.btnAction === "edit") {
      // console.log(clickedInvestigation, "clicked investigation");

      // Check if the investigation object is found
      if (clickedInvestigation) {
        // Get the url from the key using lambda function api
        try {
          const getLink = await fetch(
            "https://0t38n05kd3.execute-api.ap-south-1.amazonaws.com/default/presigned_url",
            {
              method: "POST",
              body: JSON.stringify({
                bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
                report_key_array: [clickedInvestigation.key],
              }),
            }
          );
          const link = await getLink.json();
          setRecordURL(link?.presigned_url_array[0]);
          setSelectedReport(clickedInvestigation);

          if (button.btnAction === "edit") {
            const selectedReportDetailsResponse = await getCuratedFilesList(
              physician.physician._id,
              patientId,
              clickedInvestigation._id
            );

            if (!selectedReportDetailsResponse.error)
              setSelectedReportDetails(
                selectedReportDetailsResponse?.data?.fieldDetails
              );
          }

          // Open the modal with the recordURL
          setViewReportModalOpen(true);
        } catch {}
      }
    } else if (button.btnAction === "download") {
      // Logic for download
      try {
        const downloadResponse = await downloadCuratedFile(
          physician.physician._id,
          patientId,
          { reports: [reportId] }
        );
        if (!downloadResponse.error) {
          window.open(downloadResponse?.data, "_blank");
          setDownloadStatus({ success: true, fail: false });
          // var newWnd = window.open(downloadResponse?.data, "_blank");
          // newWnd.opener = null;
        }
      } catch (error) {
        console.error("Error fetching file details:", error);
        setDownloadStatus({ success: false, fail: true });
      }
    }
  };

  const getCuratedFiles = async () => {
    try {
      const investigationsResponse = await getCuratedFilesList(
        physician.physician._id,
        patientId
      );
      if (!investigationsResponse.error) {
        setAllFiles(investigationsResponse.data?.curatedFiles);
        setInvestigations(investigationsResponse.data?.curatedFiles);
        setOptions(investigationsResponse.data?.filters);
      }
    } catch (error) {
      console.error("Error fetching file details:", error);
    }
  };

  const handleFlyerOnClose = () => {
    setDownloadStatus({ success: false, fail: false });
  };

  /**
   * Function to apply duration filter
   * @param {*} list - complete list
   * @returns - returns applied filters on list
   */
  const handleMonthFilter = (list) => {
    let temp = [];

    temp = list.filter((item) => {
      return (
        (!filterDates.startMonth ||
          // new Date(item.reportDate) >=
          new Date(
            new Date(
              item.reportDate || item.date || item.startDate || item.endDate
            ).getFullYear(),
            new Date(
              item.reportDate || item.date || item.startDate || item.endDate
            ).getMonth()
          ) >=
            new Date(
              filterDates.startMonth.year(),
              filterDates.startMonth.month()
            )) &&
        (!filterDates.endMonth ||
          new Date(
            new Date(
              item.reportDate || item.date || item.endDate || item.startDate
            ).getFullYear(),
            new Date(
              item.reportDate || item.date || item.endDate || item.startDate
            ).getMonth()
          ) <=
            // new Date(item.reportDate) <=
            new Date(filterDates.endMonth.year(), filterDates.endMonth.month()))
      );
    });

    return temp;
  };

  const handleApplyFilter = (selectedFilters) => {
    // console.log(selectedFilters);

    let reports = [];
    let timelineEntries = [];
    if (selectedFilters.length > 0) {
      reports = allFiles.filter((file) =>
        selectedFilters.includes(file.reportType.reportType.name)
      );
      timelineEntries = completeTimeline.filter((entry) => {
        // console.log(entry.name, selectedFilters.includes(entry.name));

        return selectedFilters.includes(entry.name);
      });
    } else {
      reports = allFiles;
      timelineEntries = completeTimeline;
    }

    setInvestigations(handleMonthFilter(reports));
    updatePatientTimeline(handleMonthFilter(timelineEntries));
  };

  /**
   * Function to sort items in acsending or decsending order
   * @param {*} sortedField - name of field or column to be sorted
   * @param {*} dir - direction
   */
  const handleSort = (sortedField) => {
    if (investigations.length > 0) {
      let sortedProducts = [...investigations];
      let dir = currSort.dir;
      if (sortedField !== null) {
        if (currSort.field === sortedField) {
          currSort.dir *= -1;
          dir *= -1;
        } else {
          setCurrSort({ field: sortedField, dir: 1 });
          dir = 1;
        }
        sortedProducts.sort((a, b) => {
          if (a[sortedField] < b[sortedField]) {
            return dir === 1 ? -1 : 1;
          }
          if (a[sortedField] > b[sortedField]) {
            return dir === 1 ? 1 : -1;
          }
          return 0;
        });
      }
      setInvestigations(sortedProducts);
    }
  };

  useEffect(() => {
    getCuratedFiles();
    getPatientDetails();
  }, []);

  useEffect(() => {
    investigations?.length > 0 &&
      setRows(
        investigations?.map((investigation, index) => {
          return {
            _id: investigation._id,
            disabled: false,
            tableData: [
              {
                id: 1,
                text: `${getDDMMYY(investigation?.reportDate)}`,
                subText: "",
                subYellowButton: "",
                subGreyButton: "",
                star: {
                  isSubStar: false,
                  isStarred: false,
                },
                isButton: false,
                disableButton: "",
                buttonList: [],
                containsProfileImage: false,
              },
              {
                id: 2,
                text: "",
                subText: "",
                subYellowButton: "",
                subGreyButton: "",
                star: {
                  isSubStar: false,
                  isStarred: false,
                },
                isButton: false,
                disableButton: `${investigation?.reportType?.reportType?.name}`,
                buttonList: [],
                containsProfileImage: false,
              },
              {
                id: 3,
                text: `${investigation?.filename}`,
                subText: "",
                subYellowButton: "",
                subGreyButton: "",
                star: {
                  isSubStar: false,
                  isStarred: false,
                },
                disableButton: "",
                isButton: false,
                buttonList: [],
                containsProfileImage: false,
              },
              {
                id: 4,
                seeMoreCell: true,
                text: `${investigation?.impression}`,
                subText: "",
                subYellowButton: "",
                subGreyButton: "",
                star: {
                  isSubStar: false,
                  isStarred: false,
                },
                disableButton: "",
                isButton: false,
                buttonList: [],
                containsProfileImage: false,
                cellTextStyle: { alignSelf: "flex-start" },
              },
              {
                id: 5,
                text: "",
                subText: "",
                subYellowButton: "",
                subGreyButton: "",
                star: {
                  isSubStar: false,
                  isStarred: false,
                },
                isButton: true,
                disableButton: "",
                buttonList: [
                  {
                    btntext: "View",
                    btnIcon: "",
                    btnAction: "view",
                  },
                  {
                    btntext: "Edit",
                    btnIcon: "",
                    btnAction: "edit",
                  },
                  {
                    btntext: "Download",
                    btnIcon: "",
                    btnAction: "download",
                  },
                ],
                containsProfileImage: false,
              },
            ],
          };
        })
      );
  }, [investigations]);

  let columns = [
    {
      id: 1,
      label: "Date",
      subText: "(of Test Taken)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("reportDate"),
      minWidth: "105px",
      width: "14%",
    },
    {
      id: 2,
      label: "Type",
      subText: "(Type of Test)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("reportName"),
      minWidth: "117px",
      width: "16%",
    },
    {
      id: 3,
      label: "Report",
      subText: "(Report Name)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("filename"),
      minWidth: "105px",
      width: "14%",
    },
    {
      id: 4,
      label: "Impression",
      subText: "(Impression by the doctor)",
      isIcon: false,
      iconsList: [],
      sortingRequired: false,
      minWidth: "180px",
      width: "24%",
    },
    {
      id: 5,
      label: "Action",
      subText: "",
      isIcon: false,
      iconsList: [],
      sortingRequired: false,
      minWidth: "200px",
      width: "28%",
    },
  ];

  return (
    <div className="investigations-treatment-frame">
      <div className="IT-heading-frame">
        <h6 className="h6-400 dark-grey">
          {!timelineView ? "Investigations & Treatment" : "Timeline"}
        </h6>
        <div className="IT-options-frame">
          {/* <input className="IT-search-bar" placeholder="Search" type="text" /> */}
          <button className="IT-buttons" onClick={handleFilter}>
            Filter{" "}
            <img
              className="IT-button-icon"
              alt="button-icons"
              src={filterIcon}
            />
          </button>
          {!timelineView ? (
            <button
              className="IT-buttons"
              onClick={() => {
                !showMore &&
                  updateBreadCrumb([
                    { name: "Dashboard", url: "/dashboard" },
                    {
                      name: `${patientDetails.firstName} ${patientDetails.lastName}`,
                      url: `/patient/${patientId}`,
                    },
                    { name: "Timeline" },
                  ]);
                setTimelineView(true);
              }}
            >
              Timeline View{" "}
              <img
                className="IT-button-icon"
                alt="button-icons"
                src={timelineIcon}
              />
            </button>
          ) : (
            <button
              className="IT-buttons"
              onClick={() => {
                !showMore &&
                  updateBreadCrumb([
                    { name: "Dashboard", url: "/dashboard" },
                    {
                      name: `${patientDetails.firstName} ${patientDetails.lastName}`,
                      url: `/patient/${patientId}`,
                    },
                    { name: "Investigation and Treatment" },
                  ]);
                setTimelineView(false);
              }}
            >
              Table View{" "}
              <img
                className="IT-button-icon"
                alt="button-icons"
                src={tableViewIcon}
              />
            </button>
          )}
          {showMore ? (
            <button
              className="IT-buttons"
              onClick={() => {
                setShowMore(false);
                handleShowMore(true);
              }}
            >
              Show More{" "}
              <img
                className="IT-button-icon"
                alt="button-icons"
                src={showMoreIcon}
              />
            </button>
          ) : (
            <button
              className="IT-buttons"
              onClick={() => {
                setShowMore(true);
                handleShowMore(false);
              }}
            >
              Show Less{" "}
              <img
                className="IT-button-icon"
                alt="button-icons"
                src={showLessIcon}
              />
            </button>
          )}
        </div>
      </div>
      <div style={{ width: "100%" }}>
        {!timelineView ? (
          <Table
            columnList={columns}
            rowList={rows}
            screen="patient-details-IT"
            onButtonClick={handleButtonClick}
            view={showMore ? "minimized" : "expanded"}
          />
        ) : (
          <Timeline view={showMore ? "minimized" : "expanded"} />
        )}
      </div>
      {/* Show Edit Record Modal when delete button in the table is clicked*/}
      {isViewReportModalOpen && (
        <ViewReportModal
          screen={"table"}
          type={viewModalType}
          report={selectedReport}
          reportURL={recordURL}
          onClose={() => setViewReportModalOpen(false)}
          fields={selectedReportDetails}
          patientId={patientId}
          physicianId={physician.physician._id}
        />
      )}
      {/* Show Filter Modal when Filter button in the table is clicked*/}
      {isFilterModalOpen && (
        <InvestigationsFilter
          onClose={() => setIsFilterModalOpen(false)}
          options={options}
          applyFilter={handleApplyFilter}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          filterDates={filterDates}
          setFilterDates={setFilterDates}
        />
      )}
      {downloadStatus.success && (
        <FlyerMessage
          message={"Download successful!"}
          onClose={handleFlyerOnClose}
        />
      )}
      {downloadStatus.fail && (
        <FlyerMessage
          message={"Download failed!"}
          onClose={handleFlyerOnClose}
        />
      )}
    </div>
  );
};

export default InvestigationAndTreatment;
